
const messagePreview = /* GraphQL */ `
  fragment MessagePreview on Message {
    messageType
    channelType
    bodyText
    createdAt
  }
`;

const messageReadStatusStaff = /* GraphQL */ `
  fragment MessageReadStatusStaff on MessageReadStatus {
    readUpToDateTime
    group
    userID
    staffID
  }
`;

const messageReadStatusDevice = /* GraphQL */ `
  fragment MessageReadStatusDevice on MessageReadStatus {
    readUpToDateTime
    group
    userID
    deviceID
  }
`;

const messageFields = /* GraphQL */ `
  fragment MessageFields on Message {
    id
    createdAt
    channelType
    group
    bodyText
    senderName
    isReadS
    isReadBy {
      items {
        id 
        userID
      }
    }
    sender {
      id
    }
    messageType
    attachmentLink
    contentType
    attachment{
      id
      s3Key
      fileSize
      contentType
      expirationDate
      shortenUrl {
        items {
          id
          shortenId
        }
        nextToken
      }
    }
    hasParts
  }
`;

export const staffsByGroupStatus = /* GraphQL */ `
${messagePreview}
${messageReadStatusStaff}
query StaffsByGroupStatus(
  $group: String
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStaffFilterInput
  $sortDirectionMessage: ModelSortDirection
  $filterMessage: ModelMessageFilterInput
  $createdAtFilter: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
) {
  staffsByGroupStatus(
    group: $group
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      photo
      smsLastMessageTimestamp
      smsLastMessage
      status
      messages(
        sortDirection: $sortDirectionMessage
        filter: $filterMessage
        limit: 25
        createdAt: $createdAtFilter
      ) {
        items {
          ...MessagePreview
        }
      }
      messageReadStatus {
        items {
          ...MessageReadStatusStaff
        }
      }
    }
    nextToken
  }
}
`;

export const staffsByGroupMessageTime = /* GraphQL */ `
${messagePreview}
${messageReadStatusStaff}
query StaffsByGroupMessageTime(
  $group: String
  $smsLastMessageTimestamp: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelStaffFilterInput
  $sortDirectionMessage: ModelSortDirection
  $filterMessage: ModelMessageFilterInput
  $createdAtFilter: ModelStringKeyConditionInput
  $limitMessages: Int
  $limit: Int
  $nextToken: String
) {
  staffsByGroupMessageTime(
    group: $group
    smsLastMessageTimestamp: $smsLastMessageTimestamp
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      photo
      smsLastMessageTimestamp
      smsLastMessage
      status
      messages(
        sortDirection: $sortDirectionMessage
        filter: $filterMessage
        limit: $limitMessages
        createdAt: $createdAtFilter
      ) {
        items {
          ...MessagePreview
        }
      }
      messageReadStatus {
        items {
          ...MessageReadStatusStaff
        }
      }
    }
    nextToken
  }
}
`;

export const devicesByGroupStatus = /* GraphQL */ `
${messagePreview}
${messageReadStatusDevice}
query DevicesByGroupStatus(
  $group: String
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDeviceFilterInput
  $sortDirectionMessage: ModelSortDirection
  $filterMessage: ModelMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  devicesByGroupStatus(
    group: $group
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      deviceName
      deviceLastMessageTimestamp
      deviceLastMessage
      status
      messages(
        sortDirection: $sortDirectionMessage
        filter: $filterMessage
        limit: 100
      ) {
        items {
          ...MessagePreview
        }
      }
      messageReadStatus {
        items {
          ...MessageReadStatusDevice
        }
      }
    }
    nextToken
  }
}
`;
export const getStaff = /* GraphQL */ `
  query GetStaff($id: ID!) {
    getStaff(id: $id) {
      id
      firstName
      lastName
      displayName
      status
      phone
      photo
      smsLastMessage
    }
  }
`;

export const getDevice = /* GraphQL */ `
  query GetDevice($id: ID!) {
    getDevice(id: $id) {
      id
      deviceName
      phoneNumber
      status
      deviceLastMessage
    }
  }
`;
export const messagesByStaffId = /* GraphQL */ `
  ${messageFields}
  query MessagesByStaffId(
    $staffId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByStaffId(
      staffId: $staffId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...MessageFields
        smsStatus
        smsSendInformation
      }
      nextToken
    }
  }
`;
export const messagesByDeviceId = /* GraphQL */ `
  ${messageFields}
  query MessagesByDeviceId(
    $deviceId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messagesByDeviceId(
      deviceId: $deviceId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ...MessageFields
        deviceSmsStatus
        deviceSmsSendInformation
        deviceAssociateId
        deviceAssociate {
          id
          firstName
          lastName
          displayName
        }
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      createdAt
      channelType
      bodyText
      smsStatus
      smsSendInformation
      isReadS
      attachmentLink
      linkExpiryDate
      deviceSmsStatus
      deviceSmsSendInformation
    }
  }
`;

export const getAttachment = /* GraphQL */ `
  query GetAttachment($id: ID!) {
    getAttachment(id: $id) {
      id
      s3Key
      fileSize
      expirationDate
      contentType
    }
  }
`;

export const vehiclesByGroup = /* GraphQL */ `
  query VehiclesByGroup(
    $group: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVehicleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    vehiclesByGroup(
      group: $group
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        group
        name
        status
        mileage
        vin
        licensePlate
        gasCard
        company {
          id
          option
        }
      }
      nextToken
    }
  }
`;

export const accidentsByVehicle = /* GraphQL */ `
  query AccidentsByVehicle(
    $vehicleId: String
    $accidentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccidentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accidentsByVehicle(
      vehicleId: $vehicleId
      accidentDate: $accidentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accidentDate
        staff {
          id
          firstName
          lastName
          displayName
        }
      }
      nextToken
    }
  }
`;

export const accidentsByVehicleAndHistoryType = /* GraphQL */ `
  query AccidentsByVehicleAndHistoryType(
    $vehicleId: String
    $vehicleHistoryTypeAccidentDate: ModelAccidentByVehicelByHistoryTypeCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelAccidentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    accidentsByVehicleAndHistoryType(
      vehicleId: $vehicleId
      vehicleHistoryTypeAccidentDate: $vehicleHistoryTypeAccidentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        accidentDate
        vehicleHistoryType
        staff {
          id
          firstName
          lastName
          displayName
        }
      }
      nextToken
    }
  }
`;

export const messageReadStatusByUserAndStaff = /* GraphQL */ `
  query MessageReadStatusByUserAndStaff(
    $group: String
    $staffIDUserID: ModelMessageReadStatusByUserAndStaffCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageReadStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messageReadStatusByUserAndStaff(
      group: $group
      staffIDUserID: $staffIDUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        group
        userID
        staffID
        readUpToDateTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const messageReadStatusByUserAndDevice = /* GraphQL */ `
  query MessageReadStatusByUserAndDevice(
    $group: String
    $deviceIDUserID: ModelMessageReadStatusByUserAndDeviceCompositeKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelMessageReadStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    messageReadStatusByUserAndDevice(
      group: $group
      deviceIDUserID: $deviceIDUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        group
        userID
        deviceID
        readUpToDateTime
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const getStaffByRouteDeviceId = /* GraphQL */ `
  query GetStaffByRouteDeviceId($deviceId: ID!, $filter: ModelRouteFilterInput) {
    routeByDevice(routeDeviceId: $deviceId, filter: $filter) {
      items {
        createdAt
        updatedAt
        staff {
          id
          firstName
          lastName
          displayName
        }
      }
    }
  }
`;
